import { render, staticRenderFns } from "./DictionarySpecialities.vue?vue&type=template&id=4af6fc7d&"
import script from "./DictionarySpecialities.vue?vue&type=script&lang=js&"
export * from "./DictionarySpecialities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports